import { Reveal, Eyebrow } from "./motion";

export default function About({ profile }) {
  const chapters = [
    { n: "01", title: "The Agent", body: profile?.bio },
    { n: "02", title: "Credentials", list: profile?.credentials },
    { n: "03", title: "Recognition", list: profile?.awards },
  ];

  return (
    <section id="about" data-testid="about-section" className="bg-[#FAF9F6] py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-20">
          <div className="lg:col-span-8">
            <Reveal><Eyebrow>About</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#0A1128] mt-5 text-balance">
                A considered approach to <span className="italic text-[var(--gold)]">exceptional</span> homes.
              </h2>
            </Reveal>
          </div>
          {profile?.headshot && (
            <Reveal delay={0.15} className="lg:col-span-4 hover-img">
              <img src="https://customer-assets-agu9un31.emergentagent.net/job_property-showcase-572/artifacts/7lir7qvk_Mabel%20McMillan_057_1.webp" alt={profile?.name} className="w-full h-[30rem] object-contain" />
            </Reveal>
          )}
        </div>

        <div className="grid md:grid-cols-3 gap-x-8 gap-y-14 border-t border-[#0A1128]/10 pt-16">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <div className="font-serif text-5xl text-[var(--gold)]/70 mb-4">{c.n}</div>
              <h3 className="font-serif text-2xl text-[#0A1128] mb-4">{c.title}</h3>
              {c.body && <p className="text-[var(--slate)] leading-relaxed text-[15px]">{c.body}</p>}
              {c.list && (
                <ul className="space-y-3">
                  {c.list.map((item) => (
                    <li key={item} className="text-[var(--slate)] text-[15px] leading-snug flex gap-3">
                      <span className="text-[var(--gold)] mt-1">—</span>{item}
                    </li>
                  ))}
                </ul>
              )}
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-20 flex flex-wrap gap-3">
            {(profile?.service_areas || []).map((area) => (
              <span key={area} className="px-5 py-2 border border-[#0A1128]/15 text-sm text-[#0A1128] tracking-wide">
                {area}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
